import React from 'react';

const ProgressBar = ({ progress, label, color = '#14B8A6', showLabel = true, height = 'h-2' }) => {
  const clampedProgress = Math.min(Math.max(progress, 0), 100);
  
  const getColor = () => {
    if (clampedProgress >= 75) return '#10B981'; // Green
    if (clampedProgress >= 50) return '#F59E0B'; // Yellow
    if (clampedProgress >= 25) return '#F97316'; // Orange
    return '#EF4444'; // Red
  };

  const displayColor = color === 'auto' ? getColor() : color;

  return (
    <div className="w-full">
      {showLabel && (
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-medium text-gray-700">{label}</span>
          <span className="text-sm font-bold" style={{ color: displayColor }}>
            {clampedProgress.toFixed(0)}%
          </span>
        </div>
      )}
      <div className={`w-full bg-gray-200 rounded-full ${height} overflow-hidden`}>
        <div
          className="h-full rounded-full transition-all duration-500 ease-out"
          style={{
            width: `${clampedProgress}%`,
            backgroundColor: displayColor
          }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;